import React from 'react';

interface Props {
    title: string;
    value: string | number;
    icon: string;
    subtitle?: string;
    colorClass?: string;
}

const KpiCard: React.FC<Props> = ({ title, value, icon, subtitle }) => {
    return (
        <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--text-secondary)' }}>{title}</h3>
                <span style={{ fontSize: '1.5rem', backgroundColor: 'rgba(190, 242, 100, 0.1)', padding: '0.5rem', borderRadius: '0.5rem' }}>
                    {icon}
                </span>
            </div>
            <div style={{ fontSize: '1.875rem', fontWeight: '700', color: 'var(--accent)' }}>
                {value}
            </div>
            {subtitle && (
                <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                    {subtitle}
                </div>
            )}
        </div>
    );
};

export default KpiCard;
